import { API_PREFIX_V1 } from "../constants";
 
// App
export const ROUTE_PAGE_NOT_FOUND = `/404`;
export const ROUTE_LOGIN = `/login`;
export const ROUTE_ADMIN_LOGIN = `/admin/login`
export const ROUTE_FORGET_PASSWORD = `/forget-password`;
export const ROUTE_RESET_PASSWORD = `/reset-password`;
export const ROUTE_PROFILE = `/profile`;
 
// API
export const LOGIN = `${API_PREFIX_V1}auth/login`;
export const LOGOUT = `${API_PREFIX_V1}auth/logout`;
export const FORGET_PASSWORD = `${API_PREFIX_V1}auth/forget-password`;
export const API_ADMIN_TOKEN_EXCHANGE = `${API_PREFIX_V1}auth/auth-exchange`;
export const API_GET_USER_DETAILS = `${API_PREFIX_V1}auth/users-details`;
export const API_GET_MY_PERMISSIONS = `${API_PREFIX_V1}auth/user/my-permissions`;
export const API_ROLES = `${API_PREFIX_V1}roles/roles`;
export const API_ROLE = `${API_PREFIX_V1}roles`;
export const API_PERMISSIONS = `${API_PREFIX_V1}roles/permissions`;
export const API_ROLE_LOGS = `${API_PREFIX_V1}auth/role-logs`;
export const API_APP_VERSION = `${API_PREFIX_V1}app/version`;
